interface SEOMetaProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogType?: string;
  schema?: Record<string, unknown> | Record<string, unknown>[];
}

export default function SEOMeta({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogImage,
  ogType = 'website',
  schema,
}: SEOMetaProps) {
  const siteName = '尾巴漫画网';
  const fullTitle = title.includes(siteName) ? title : `${title} - ${siteName}`;
  const fullOgTitle = ogTitle || fullTitle;
  const fullOgDesc = ogDescription || description;

  const meta = {
    title: fullTitle,
    description,
    keywords: keywords || '尾巴漫画网,好看的韩国漫画,韩漫在线免费阅读,韩漫,免费漫画',
    canonicalUrl: canonicalUrl || 'https://www.weibamanhua.com',
    ogTitle: fullOgTitle,
    ogDescription: fullOgDesc,
    ogImage: ogImage || '',
    ogType,
  };

  const jsonLdSchemas = Array.isArray(schema) ? schema : (schema ? [schema] : []);

  return (
    <>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <meta name="keywords" content={meta.keywords} />
      <link rel="canonical" href={meta.canonicalUrl} />
      <meta property="og:title" content={meta.ogTitle} />
      <meta property="og:description" content={meta.ogDescription} />
      <meta property="og:type" content={meta.ogType} />
      <meta property="og:url" content={meta.canonicalUrl} />
      <meta property="og:locale" content="zh_CN" />
      <meta property="og:site_name" content={siteName} />
      {meta.ogImage && <meta property="og:image" content={meta.ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={meta.ogTitle} />
      <meta name="twitter:description" content={meta.ogDescription} />
      {meta.ogImage && <meta name="twitter:image" content={meta.ogImage} />}
      {jsonLdSchemas.map((s, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </>
  );
}